
export default {
  props: {
    cdnData: Array,
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.stickyHeader);
  },
  methods: {
    formatPrice(value) {
      return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    handleToggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getArrayWithExpandCondition(arr) {
      return arr;
    },
    stickyHeader() {
      const header = this.$el.querySelector(".sticky-header");
      const parentDiv = this.$el.querySelector(".parent-div");
      const cartContainer = this.$el.querySelector(".cart-container");

      if (!header || !parentDiv || !cartContainer || !this.isExpanded) {
        this.isSticky = false;

        return;
      }

      const parentDivRect = parentDiv.getBoundingClientRect();
      const cartContainerRect = cartContainer.getBoundingClientRect();

      if (
        +parentDivRect.y.toFixed(0) <= -133 &&
        +parentDivRect.y.toFixed(0) >=
          (Math.abs(cartContainerRect.height) + 248 - 300) * -1
      ) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.stickyHeader);
  },
  data() {
    return {
      isExpanded: false,
      areTitlesFloating: false,
      cdnPlans: this.cdnData,
      isSticky: false,
    };
  },
  computed: {
    rowsNumber() {
      if (this.isExpanded) return 100;
      else return 5;
    },
    featuresTitle() {
      const planItems = this.cdnData[0].description.planItems;
      const titles = [];

      planItems.forEach((item) => {
        item.items.forEach((i) => {
          titles.push(i.name);
        });
      });

      return titles;
    },
    freePlanValues() {
      const planItems = this.cdnData[0].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
    standardPlanValues() {
      const planItems = this.cdnData[1].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
    advancePlanValues() {
      const planItems = this.cdnData[2].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
    enterprisePlanValues() {
      const planItems = this.cdnData[3].description.planItems;
      const values = [];

      planItems.forEach((item) => {
        return item.items.forEach((i) => {
          values.push(i);
          return;
        });
      });

      return values;
    },
  },
  watch: {
    rowsNumber: function () {
      if (!this.isExpanded) {
        this.isSticky = false;
      }
    },
  },
};
